var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.824,
    height: 15.111,
    viewBox: "0 0 12.824 15.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15070.001 -12531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210,19.4a1.886,1.886,0,1,0,3.772,0V19h-.754v.4a1.132,1.132,0,0,1-2.263,0V19H210Z",
    transform: "translate(-15275.474 12524.825)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6,12.805a.39.39,0,0,1-.04-.167V8.67a4.149,4.149,0,0,0-8.3,0v3.968a.369.369,0,0,1-.041.17l-1.232,2.018h10.844ZM210.413,2A1.886,1.886,0,0,1,212.3,3.871a5.055,5.055,0,0,1,3.018,4.8v3.876l1.469,2.49a.377.377,0,0,1-.337.545H204.377a.377.377,0,0,1-.377-.361.386.386,0,0,1,.04-.186l1.468-2.49V8.67a5.055,5.055,0,0,1,3.018-4.8A1.886,1.886,0,0,1,210.413,2Zm0,1.509a5.087,5.087,0,0,1,1.1.12,1.132,1.132,0,0,0-2.2,0,5.1,5.1,0,0,1,1.1-.12Z",
    transform: "translate(-15274 12529)",
    fill: "#0d3b66"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification_bell.b737fbe5700f88c2e184cbad19f7a5db.svg";
export { ForwardRef as ReactComponent };